// extracted by mini-css-extract-plugin
export default {"bulletsContainer":"b5uGsq07_tL1CbcihpXB","subtextBullet":"ndJ7wtfA7VQTZXw9n6zf"};